<template>
  <div class="experience inverse">
    <div class="container">
      <div class="section">
        <div class="title-col">
          <h3>Experience</h3>
          <hr>
        </div>
        <div class="content-col">
          <ul>
            <li>
              <strong>Capital One</strong>  
              <em>February 2016 - Present</em>
              <span>Senior Engineer</span>
            </li>
            <li>
              <strong>Capital One (Contractor)</strong>  
              <em>October 2014 - February 2016</em>
              <span>Senior UI/UX Technologist</span>
            </li>
            <li>
              <strong>Big River Advertising</strong>  
              <em>November 2012 - October 2014</em>
              <span>Creative Technologist</span>
            </li>
            <li>
              <strong>The Martin Agency</strong>  
              <em>October 2010 - November 2012</em>
              <span>Senior Mobile & Web Developer</span>
            </li>
            <li>
              <strong>AgencyNet Interactive</strong>  
              <em>May 2007 - October 2010</em>
              <span>iOS & Flash Developer</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Experience'
}
</script>
